<template>
	<div class="function-zone">
		<el-row>
			<el-col class="function">
				<div class="total" v-if="hint" :style="[hint.style]">
					{{ hint.content }}
				</div>
				<div class="button" v-if="btnList">
					<div class="left-button">
						<el-badge
							v-for="item in filterBtn('left')"
							:key="item.name"
							:value="item.badge && item.badge.value"
							:hidden="!(item.badge && item.badge.value)"
							v-bind="item.badge"
							class="badge"
						>
							<el-button
								:style="{ float: item.position || 'left' }"
								v-bind="item.attribute"
								@click="item.btnClick"
								>{{ item.name }}</el-button
							>
						</el-badge>
					</div>
					<div class="right-button">
						<el-badge
							v-for="item in filterBtn('right')"
							:key="item.name"
							:value="item.badge && item.badge.value"
							:hidden="!(item.badge && item.badge.value)"
							v-bind="item.badge"
							class="badge"
						>
							<el-button
								:style="{ float: item.position || 'right' }"
								v-bind="item.attribute"
								@click="item.btnClick"
								>{{ item.name }}</el-button
							>
						</el-badge>
					</div>
				</div>
				<component v-if="custom" :is="custom.type" v-bind="custom"></component>
			</el-col>
			<el-col :span="24" class="alert" v-if="alert">
				<el-alert
					v-if="alert.visible"
					:title="alert.title"
					:type="alert.type"
					:close-text="alert.closeText"
					v-bind="alert"
					@close="close"
				>
				</el-alert>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	name: 'functionalZone',
	props: {
		btnList: {
			type: Array,
			required: false,
		},
		custom: {
			type: Object,
			required: false,
		},
		alert: {
			type: Object,
			required: false,
		},
		hint: {
			type: Object,
			required: false,
		},
	},
	data() {
		return {};
	},
	computed: {},
	methods: {
		filterBtn(position) {
			let { showBtn } = this;
			return this.btnList.filter(item => item.position === position && showBtn(item.showBtn));
		},
		close() {
			this.alert && this.alert.close();
		},
		showBtn(val) {
			if (typeof val === 'undefined') {
				return true;
			} else if (typeof val === 'function') {
				return val();
			} else {
				return val;
			}
		},
	},
	components: {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.function-zone {
	padding: 0 12px;
	.function {
		padding: 10px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.total {
			font-size: 16px;
			color: #333;
			font-weight: bold;
		}
		.button {
			flex: 1;
			// margin-bottom: 5px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.left-button {
				display: flex;
				justify-content: flex-start;
				align-items: center;
			}
			.right-button {
				display: flex;
				justify-content: flex-end;
				align-items: center;

				.badge {
					margin: 0 0 0 10px;
				}
			}
			.badge {
				margin: 0 15px;
			}
		}
	}
	.alert {
		margin: 5px 0 10px;
		.el-alert {
			margin: 5px 0;
		}
	}
}
</style>
